import { RuleObject } from "antd/lib/form";

type Validatable = string | number | null | undefined;

/** 數值型別驗證工具集：整數、正數、正整數判斷 */
export const valueValidator = {
  isInteger: (value: string | number): boolean => {
    const num = Number(value);
    return !Number.isNaN(num) && Number.isInteger(num);
  },
  isPositiveNumber: (value: string | number, allowZero = false): boolean => {
    const num = Number(value);
    if (Number.isNaN(num)) return false;
    return allowZero ? num >= 0 : num > 0;
  },
  isPositiveInteger: (value: Validatable): boolean => {
    if (value == null) return false;
    if (typeof value === "string" && value.trim() !== value) return false;
    const num = Number(value);
    return Number.isInteger(num) && num > 0;
  },
};

/** 台灣證號格式驗證工具集：身分證字號、統一編號 */
export const FieldValidator = {
  idNumber: (value: any) => {
    if (value == null) return false;
    const normalizedValue = String(value).trim();
    const regex = /^[A-Z][12]\d{8}$/;
    return regex.test(normalizedValue);
  },
  ubn: (value: any) => {
    if (value == null) return false;
    const normalizedValue = String(value).trim();
    const regex = /^\d{8}$/;
    return regex.test(normalizedValue);
  },
};

/**
 * 集中管理 Ant Design Form.Item 的自訂驗證函式。
 *
 * 用途：
 * - 提供可重複使用的欄位驗證邏輯（例如：身分證字號、統一編號、數值格式等）。
 * - 統一錯誤訊息與驗證規則，避免各頁面重複實作。
 *
 * validator 函式格式：
 * - `(_rule: RuleObject, value: any) => Promise<void>`
 * - 驗證通過：`return Promise.resolve()`
 * - 驗證失敗：`return Promise.reject(new Error("錯誤訊息"))`
 */

export const formItemValidator = {
  idNumber: (message: string = "請填入正確的身分字號，須為 10 碼且首位大寫英文") => {
    return (_: RuleObject, value: any) => {
      return FieldValidator.idNumber(value) ? Promise.resolve() : Promise.reject(new Error(message));
    };
  },
  ubn: (message: string = "請填入正確的統一編號，須為 8 位數字") => {
    return (_: RuleObject, value: any) => {
      return FieldValidator.ubn(value) ? Promise.resolve() : Promise.reject(new Error(message));
    };
  },
};

/** 預設匯出，等同 valueValidator 數值型別驗證工具集 */
export default valueValidator;
